export const iconFontAwesomeBuildingsHouseChimneyMedical = (
	<i className="fa-solid fa-house-chimney-medical"></i>
);
